<ng-container *ngIf="formGroup.get('currentYearIncome') && formGroup.get('previousYearIncome')">
  <h5>Business Income</h5>
  <div class="row">
    <div class="offset-4 col-4">
      <p><strong>Current year</strong></p>
    </div>
    <div class="col-4">
      <p><strong>Previous year</strong></p>
    </div>
  </div>
  <div class="row" [formGroup]="formGroup">
    <div class="col-4 d-flex align-items-center">
      <strong>Income - Net profit before tax<br> (if loss, show negative)</strong>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>Income amount</mat-label>
        <input matInput placeholder="Income amount" matInputCommified formControlName="currentYearIncome">
        <span matPrefix>$&nbsp;</span>
        <mat-error>
          <app-validation-partial [formGroup]="formGroup" [fieldName]="'currentYearIncome'">
          </app-validation-partial>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>Income amount</mat-label>
        <input matInput placeholder="Income amount" matInputCommified formControlName="previousYearIncome">
        <span matPrefix>$&nbsp;</span>
        <mat-error>
          <app-validation-partial [formGroup]="formGroup" [fieldName]="'previousYearIncome'">
          </app-validation-partial>
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-8">
      <strong>Allowable Addbacks</strong>
    </div>
    <div class="col-4 text-end">
      <button mat-raised-button color="primary" type="button" class="fmc-button-primary" (click)="addAddback(formGroup)">Add
        allowable addback
      </button>
    </div>
  </div>

  <ng-container *ngIf="formGroup.get('allowableAddBacks')">
    <div class="row" *ngFor="let addback of formGroup.get('allowableAddBacks').controls; let i = index;">
      <div class="col-4" [formGroup]="addback">
        <mat-form-field appearance="outline" [ngClass]="{'col-6' : (addback.value.addbackType === 'other-company'), 'col-12': (addback.value.addbackType !== 'other-company')}">
          <mat-label>Addback types</mat-label>
          <mat-select placeholder="Addback types" formControlName="addbackType">
            <mat-option [disabled]="" *ngFor="let type of debtServiceAddbacksTypes" [value]="type.id">{{type.text}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="example-full-width col-6" *ngIf="addback.value.addbackType === 'other-company'">
          <mat-label>Description</mat-label>
          <input matInput placeholder="Description" formControlName="addbackDescription">
        </mat-form-field>
      </div>
      <div class="col-4" [formGroup]="addback">
        <mat-form-field appearance="outline">
          <mat-label>Income amount</mat-label>
          <input matInput placeholder="Income amount" matInputCommified formControlName="addbackCurrentYearIncome">
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            <app-validation-partial [formGroup]="formGroup" [fieldName]="'addbackCurrentYearIncome'">
            </app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-3" [formGroup]="addback">
        <mat-form-field appearance="outline">
          <mat-label>Income amount</mat-label>
          <input matInput placeholder="Income amount" matInputCommified formControlName="addbackPreviousYearIncome">
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            <app-validation-partial [formGroup]="formGroup" [fieldName]="'addbackPreviousYearIncome'">
            </app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-1">
        <button type="button" mat-icon-button (click)="removeAddback(formGroup, i)" color="warn">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <div class="row" *ngIf="formGroup.get('allowableAddBacks').errors?.noSameValues">
      <div class="col-12">
        <mat-error>
          Addback types must be unique. Max of 2 "Other" addbacks are allowed.
        </mat-error>
      </div>
    </div>
  </ng-container>

  <div class="row" [formGroup]="formGroup">
    <div class="col-4 d-flex align-items-center">
      <strong>Total income including addbacks</strong>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>Total amount</mat-label>
        <input matInput placeholder="Total amount" matInputCommified formControlName="currentYearTotalIncome"
               [readonly]="true">
        <span matPrefix>$&nbsp;</span>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>Total amount</mat-label>
        <input matInput placeholder="Total amount" matInputCommified formControlName="previousYearTotalIncome"
               [readonly]="true">
        <span matPrefix>$&nbsp;</span>
      </mat-form-field>
    </div>
  </div>
</ng-container>
